import React, { useState, useEffect } from "react";
import "./sales.scss";
import DataTable from "./DataTable/DataTable";
import { Dropdown, Modal } from "react-bootstrap";

import { Api_Url_Referral } from "../../../utils/ApiUrl";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import Loader from "../../../hooks/loader";
const SalesRound = ({ setindexwait }) => {
  const val = localStorage.getItem("accessToken");
  const [project, setProject] = useState("NFA");
  const [selectedItem, setSelectedItem] = useState(null);
  const [refLists, setRefLists] = useState([]);
  const [loaderr, setLoarder] = useState(false);
  const tok = localStorage?.getItem("accessToken");
  const [count, setCount] = useState(0);
  const [pages, setPages] = useState([]);
  const [allRounds, setAllRounds] = useState([]);

  const GetAllRounds = async () => {
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url_Referral}/project-presale/admin/referral/salesRounds?creatorWalletAddress=${selectedItem?.creatorWalletAddress}`,
      // &offset=${offset}&&limit=5
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    axios(config)
      .then(function (response) {
        // setLoader(false);
        setCount(response.data.data.count);
        setAllRounds(response.data.data.roundDetails);
        let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
        setPages(arr);
      })
      .catch(function (error) {
        // console.log(error);
        // setLoader(false);
      });
    // }
  };

  useEffect(() => {
    if (selectedItem) {
      GetAllRounds();
    }
  }, [selectedItem]);

  const handleItemClick = (imgSrc, text, creatorWalletAddress) => {
    setSelectedItem({ imgSrc, text, creatorWalletAddress });
    setProject(text);
  };

  const getProjectsList = async () => {
    const tok = localStorage?.getItem("accessToken");
    var config = {
      method: "get",
      url: `${Api_Url_Referral}/projects/private-sale?isPremiumProject=false`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        if (response?.data?.data?.projects?.length > 0) {
          let dummy = response?.data?.data?.projects[0];
          let dummy2 = {
            imgSrc: "",
            text: "",
          };
          dummy2.imgSrc = dummy.projectImg;
          dummy2.text = dummy.tokenSymbol;
          dummy2.creatorWalletAddress = dummy.creatorWalletAddress;
          setSelectedItem(dummy2);
        }
        setRefLists(response?.data?.data?.projects);
      })
      .catch(function (error) {
        // console.log("/projects/private-sale?isPremiumProject=false", error);
      });
  };

  useEffect(() => {
    getProjectsList();
  }, []);

  return (
    <>
      {loaderr && <Loader />}
      <section className="salesround">
        <div className="custom-container">
          {/* <button
            class="btn-back guvxgyvxvtxx"
            onClick={() => functiontogetback()}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">

              <path d="M7.88867 2.68457L5.38727 2.68457L1.99422 8.74584L4.49563 8.74584L7.88867 2.68457Z" fill="#FFF" />
              <path d="M7.88867 14.8193L5.38727 14.8193L1.99422 8.75807L3.57071 7.7102L4.49563 8.75807L7.88867 14.8193Z" fill="#FFF" />
              <path d="M8.01691 7.60645H14.962L13.6872 9.89216H6.74219L8.01691 7.60645Z" fill="#FFF" />

            </svg>
            Back
          </button> */}

          <div className="main-heading">
            <div>
              {/* <p className="selfhead">Premium Projects</p> */}
              <p className="selfhead">self serve Projects</p>
              <h6>Sale Rounds</h6>
            </div>

            <div className="newbtnsets">
              <div className="dropdown">
                <button
                  className="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedItem && (
                    <div className="projectmain">
                      {selectedItem.imgSrc && (
                        <img
                          src={selectedItem.imgSrc}
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                      )}
                      <p className="projectpara">{selectedItem.text}</p>
                    </div>
                  )}
                  <img
                    src="/assets/arrow-down.svg"
                    alt="arrow-down"
                    className="img-fluid"
                  />
                </button>
                <ul className="dropdown-menu">
                  {refLists?.map((item, index) => {
                    return (
                      <li key={index}>
                        <a
                          className="dropdown-item"
                          href="#"
                          onClick={() =>
                            handleItemClick(
                              item?.projectImg,
                              item?.tokenSymbol,
                              item?.creatorWalletAddress
                            )
                          }
                        >
                          <div className="projectmain">
                            <img
                              src={item?.projectImg}
                              alt="projectimg"
                              className="projectimg"
                              width={24}
                            />
                            <p className="projectpara">{item?.tokenSymbol}</p>
                          </div>
                        </a>
                      </li>
                    );
                  })}
                  {/* <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() => handleItemClick("", "All Projects")}
                    >
                      All Projects
                    </a>
                  </li> */}
                  {/* <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() => handleItemClick("/assets/nfa.svg", "NFA")}
                    >
                      <div className="projectmain">
                        <img
                          src="/assets/nfa.svg"
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                        <p className="projectpara">NFA</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() =>
                        handleItemClick("/assets/leia.svg", "LEIA")
                      }
                    >
                      <div className="projectmain">
                        <img
                          src="/assets/leia.svg"
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                        <p className="projectpara">Leia</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() =>
                        handleItemClick("/assets/olympus.svg", "OLYMPUS")
                      }
                    >
                      <div className="projectmain">
                        <img
                          src="/assets/olympus.svg"
                          alt="projectimg"
                          className="projectimg"
                          width={24}
                        />
                        <p className="projectpara">Olypmus</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() =>
                        handleItemClick(
                          "/assets/incentiv-new-logo.svg",
                          "INCENTIV"
                        )
                      }
                    >
                      <div className="projectmain">
                        <img
                          src="/assets/incentiv-new-logo.svg"
                          alt="projectimg"
                          className="projectimg"
                        />
                        <p className="projectpara">Incentiv</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() =>
                        handleItemClick("/assets/gems.svg", "GEMS")
                      }
                    >
                      <div className="projectmain">
                        <img
                          src="/assets/gems.svg"
                          alt="projectimg"
                          className="projectimg"
                        />
                        <p className="projectpara">Gems</p>
                      </div>
                    </a>
                  </li> */}
                </ul>
              </div>
              {/* <div className="parent-btns">
                {account && account !== ownerAddress ? (
                  <button
                    className="asasdasdasdasdasdasdds ijijijijij"
                    onClick={() => ownerWalletAddressMessage()}
                  >
                    Create Round
                  </button>
                ) : account && account == ownerAddress ? (
                  <button
                    className="asasdasdasdasdasdasdds"
                    onClick={() => setShow1(true)}
                  >
                    Create Round
                  </button>
                ) : // : account && currentTime < currentRoundd ? (
                //   <button
                //     className="asasdasdasdasdasdasdds ijijijijij"
                //     onClick={() => roundnotbecreated()}
                //   >
                //     Create DOP Round
                //   </button>
                // )

                account == undefined || account == null || account == " " ? (
                  <button
                    className="asasdasdasdasdasdasdds ijijijijij"
                    onClick={() => connectwalletfirst()}
                  >
                    Create Round
                  </button>
                ) : (
                  ""
                )}

                {account ? (
                  <a className="round-setting " onClick={() => setShow3(true)}>
                    Round Settings{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.4292 18.6167 8.2372 18.5C8.0452 18.3833 7.85786 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4457 4.5002 12.337V11.663C4.5002 11.5543 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.5712 5.38333 15.7632 5.5C15.9552 5.61667 16.1425 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5543 19.5002 11.663V12.337C19.5002 12.4457 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2375 8.84167 9.5622 9.525C8.88686 10.2083 8.54953 11.0333 8.5502 12C8.5502 12.9667 8.88753 13.7917 9.5622 14.475C10.2369 15.1583 11.0662 15.5 12.0502 15.5ZM12.0502 13.5C11.6335 13.5 11.2792 13.354 10.9872 13.062C10.6952 12.77 10.5495 12.416 10.5502 12C10.5502 11.5833 10.6962 11.229 10.9882 10.937C11.2802 10.645 11.6342 10.4993 12.0502 10.5C12.4669 10.5 12.8212 10.646 13.1132 10.938C13.4052 11.23 13.5509 11.584 13.5502 12C13.5502 12.4167 13.4042 12.771 13.1122 13.063C12.8202 13.355 12.4662 13.5007 12.0502 13.5ZM11.0002 20H12.9752L13.3252 17.35C13.8419 17.2167 14.3212 17.0207 14.7632 16.762C15.2052 16.5033 15.6092 16.191 15.9752 15.825L18.4502 16.85L19.4252 15.15L17.2752 13.525C17.3585 13.2917 17.4169 13.046 17.4502 12.788C17.4835 12.53 17.5002 12.2673 17.5002 12C17.5002 11.7333 17.4835 11.471 17.4502 11.213C17.4169 10.955 17.3585 10.709 17.2752 10.475L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2045 7.496 14.7632 7.238C14.3219 6.98 13.8425 6.784 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67953 6.97933 9.2382 7.238C8.79686 7.49667 8.39253 7.809 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.72519 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.72519 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.39186 16.1833 8.7962 16.5043 9.2382 16.763C9.6802 17.0217 10.1592 17.2173 10.6752 17.35L11.0002 20Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                ) : (
                  <a
                    className="round-setting ijijijijij"
                    onClick={() => connectwalletfirst()}
                  >
                    Round Settings{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.4292 18.6167 8.2372 18.5C8.0452 18.3833 7.85786 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4457 4.5002 12.337V11.663C4.5002 11.5543 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.5712 5.38333 15.7632 5.5C15.9552 5.61667 16.1425 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5543 19.5002 11.663V12.337C19.5002 12.4457 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2375 8.84167 9.5622 9.525C8.88686 10.2083 8.54953 11.0333 8.5502 12C8.5502 12.9667 8.88753 13.7917 9.5622 14.475C10.2369 15.1583 11.0662 15.5 12.0502 15.5ZM12.0502 13.5C11.6335 13.5 11.2792 13.354 10.9872 13.062C10.6952 12.77 10.5495 12.416 10.5502 12C10.5502 11.5833 10.6962 11.229 10.9882 10.937C11.2802 10.645 11.6342 10.4993 12.0502 10.5C12.4669 10.5 12.8212 10.646 13.1132 10.938C13.4052 11.23 13.5509 11.584 13.5502 12C13.5502 12.4167 13.4042 12.771 13.1122 13.063C12.8202 13.355 12.4662 13.5007 12.0502 13.5ZM11.0002 20H12.9752L13.3252 17.35C13.8419 17.2167 14.3212 17.0207 14.7632 16.762C15.2052 16.5033 15.6092 16.191 15.9752 15.825L18.4502 16.85L19.4252 15.15L17.2752 13.525C17.3585 13.2917 17.4169 13.046 17.4502 12.788C17.4835 12.53 17.5002 12.2673 17.5002 12C17.5002 11.7333 17.4835 11.471 17.4502 11.213C17.4169 10.955 17.3585 10.709 17.2752 10.475L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2045 7.496 14.7632 7.238C14.3219 6.98 13.8425 6.784 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67953 6.97933 9.2382 7.238C8.79686 7.49667 8.39253 7.809 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.72519 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.72519 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.39186 16.1833 8.7962 16.5043 9.2382 16.763C9.6802 17.0217 10.1592 17.2173 10.6752 17.35L11.0002 20Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                )}
              </div> */}
            </div>
          </div>
          <DataTable allRounds={allRounds} />
        </div>
      </section>
    </>
  );
};

export default SalesRound;
